module.exports = __webpack_public_path__ + "img/bingbao.2514afc7.png";